import React, { useState, useEffect } from "react";

//styles
import "../include/css/bootstrap.min.css";
import "../include/css/style.css";
import "../include/css/dev.css";

//libs
import _ from "lodash";
import { ToastContainer } from "react-toastify";
import { navigate } from "gatsby";

//component
import { SEO } from "../components/seo";
import algoliasearch from "algoliasearch";
import Header from "../components/newDesign/header/header";

const client = algoliasearch(process.env.GATSBY_ALGOLIA_APP_ID, process.env.GATSBY_ALGOLIA_API_KEY);
const index = client.initIndex(process.env.GATSBY_ALGOLIA_LISTINGS_INDEX);

const Manufacturer = (props) => {
  const data = props.pageContext;
  const [queryData, setQueryData] = useState("");
  const [keyword, setKeyword] = useState("");
  const [allMfr, setAllMfr] = useState([]);
  const [showMobileFilter, setShowMobileFilter] = useState(false);
  const [algoliaData, setAlgoliaData] = useState({});

  const initialData = async () => {
    let facets = ["*"];

    const records = await index.search("", {
      facets: facets,
      hitsPerPage: 0,
    });

    setAlgoliaData(records.facets);
  };

  useEffect(() => {
    initialData();
    // this.setState({ data: records?.facets });
  }, []);

  const toggleMobileFilter = (e) => {
    if (e) e.preventDefault();
    setShowMobileFilter(!showMobileFilter);
  };

  const handleSearch = (e) => {
    setKeyword(e.target.value);
    const mfr = data.allMfrs.filter((mfr) => mfr.node.description.toLowerCase().includes(e.target.value.toLowerCase()));
    setAllMfr(mfr);
  };

  useEffect(() => {
    setAllMfr(data.allMfrs);
  }, []);

  return (
    <>
      <ToastContainer
        position="top-right"
        hideProgressBar
        autoClose={5000}
        newestOnTop={false}
        closeOnClick
        closeButton={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Header />
      <div class="custom-categories-heading-main">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12 d-flex align-items-center">
              <h1>All Manufacturers</h1>
              <div class="form-group new-search-box">
                <input
                  type="text"
                  className="form-control search-input-new"
                  placeholder="Start typing your manufacturer"
                  value={keyword}
                  onChange={handleSearch}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="custom-categories-container h-auto">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12">
              <ul class="custom-categories-list ">
                {allMfr && allMfr.length > 0 ? (
                  allMfr
                    ?.sort((a, b) => a.node.description.localeCompare(b.node.description))
                    ?.map((sub) => (
                      <li class="custom-categories-item">
                        <a
                          href="javascript:void(0)"
                          onClick={(event) => {
                            event.preventDefault();
                            navigate(`/listings/index.cfm/mfr/${sub.node.mfrid}`);
                          }}
                        >
                          {sub.node.description}{" "}
                          {algoliaData?.["make"]?.[`${sub?.node?.description}`]
                            ? `(${algoliaData?.["make"]?.[`${sub?.node?.description}`]})`
                            : ""}
                        </a>
                      </li>
                    ))
                ) : (
                  <h3>No Record found</h3>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Manufacturer;
export const Head = () => (
  <SEO
    canonical={`https://www.salvex.com/all-manufacturers/`}
    title={`Manufacturer | Salvex`}
    description={`Browse listings by Manufacturer`}
  />
);
